import { exportGetCreditCardsByCriteria, Filter, getCreditCardsByCriteria } from '@nemuru-eng/js-api-client';

import { exportXLSX } from '@/utils/exportXLSX';
import { fetchForDataGrid } from '@/utils/fetchForDataGrid';

export function useFetchCreditCardList({ additionalFilters }: { additionalFilters?: Filter[] }) {
  const queryAdditionalFilters = additionalFilters ?? [];

  const fetchCreditCardList = async (query) => {
    const customFilters: Filter[] = queryAdditionalFilters.concat(query?.filters);
    return fetchForDataGrid(getCreditCardsByCriteria, { ...query, filters: customFilters });
  };

  const fetchXLSXExport = (query) => {
    const customFilters = query?.filters;
    return exportXLSX(exportGetCreditCardsByCriteria, { ...query, filters: customFilters });
  };

  return { fetchXLSXExport, fetchCreditCardList };
}
